import type { SourceWarning } from './types';

export function unresolvedSourceWarnings(warnings: SourceWarning[] = [], propertyIds?: string[]): SourceWarning[] {
  return warnings.filter(
    (warning) => warning.status === 'unresolved' && (!propertyIds || propertyIds.includes(warning.property_id)),
  );
}
